import React, { useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import MaterialTable from "material-table";
import Modal from '@material-ui/core/Modal';
import { chameleonSystem, managerReviewCommentsColumns, managerReviewCommentsOptions, qarManagersMenuOptions, reviewHistoryColumns, reviewHistoryOptions } from '../../helper/constants';
import '../QarSystems/QarSystems.css';
import EmployeesPerAccount from './EmployeesByAccount';
import QarManagersOptionsMenu from './QarManagersOptionsMenu';
import QarManager from './QarManager';
import { useState } from 'react';
import QarChameleonAdminEmployeeReviews from './QarChameleonAdminEmployeeReviews';
import QarFindingsByAccount from './QarFindingsByAccount';
import QarUnmatchedAccounts from './QarUnmatchedAccounts';
import QarUnmatchedAccountsInReview from './QarUnmatchedAccountsInReview';
import QarDelegatedEmployeesByAccount from './QarDelegatedEmployeesByAccount'
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';

const QarManagers = inject('RootStore')(observer(({ RootStore, ...props }) => {

    const [activeItem, setActiveItem] = useState("viewAllReviews");
    const [comment, setComment] = useState("");
    const [isInvalidInput, setIsInvalidInput] = useState(false);

    useEffect((() => {
        if (RootStore.qarStore.managersByAccount === undefined || !RootStore.qarStore.managersByAccount.length) {
            RootStore.qarStore.getAllManagersByAccountId(RootStore.qarStore.currentlySelectedAccountForReview.id, RootStore.qarStore.currentComplianceReviewId);
            RootStore.qarStore.getAllActiveSnpEmployees(RootStore.qarStore.currentComplianceReviewId);
        }
    }), [RootStore.qarStore]);

    const accountName = `${RootStore.qarStore.currentlyReviewedSystemForReview.name} / ${RootStore.qarStore.currentlySelectedAccountForReview.name} / Reviews`;

    const handleContentModalClose = () => {
        RootStore.qarStore.isCommentSectionOpened = false;
        RootStore.qarStore.isCommentFormOpened = false;
        RootStore.qarStore.isCommentPopupOpened = false;
        setIsInvalidInput(false);
    };

    const handleReviewsHistoryModalClose = () => {
        RootStore.qarStore.isReviewsHistoryOpened = false;
    };

    const backBtnClickHandler = () => {
        RootStore.qarStore.currentlySelectedAccountForReview = undefined;
        RootStore.qarStore.managersByAccount = [];
        RootStore.qarStore.employeesByAccount = [];
        RootStore.qarStore.isEmployeesByAccountOpened = false;
    };

    const submitComment = (ev) => {
        ev.preventDefault();

        if(comment === ""){
            setIsInvalidInput(true)
            return;
        }

        const data = {
            managerReviewId: RootStore.qarStore.currentlySelectedManager.managerReviewID,
            updaterId: RootStore.userStore.currentUserID,
            comment: comment
        };

        RootStore.qarStore.saveSoxComment(data);
        RootStore.qarStore.isCommentSectionOpened = false;
        RootStore.qarStore.isCommentFormOpened = false;
        RootStore.qarStore.isCommentPopupOpened = false;
    };

    const updateActiveItem = (item) => {
        setActiveItem(item);
    };

    const renderTableComponent = () => {
        switch (activeItem) {
            case qarManagersMenuOptions.viewAllEmployees:
                return <EmployeesPerAccount />;
            case qarManagersMenuOptions.viewAllReviews:
                return <QarManager accountName={accountName} />
            case qarManagersMenuOptions.viewChameleonAdmins:
                return <QarChameleonAdminEmployeeReviews />
            case qarManagersMenuOptions.viewAllFindings:
                return <QarFindingsByAccount />
            case qarManagersMenuOptions.viewUnmatchedAccounts:
                return <QarUnmatchedAccounts />
            case qarManagersMenuOptions.viewUnmatchedAccountsInReview:
                return <QarUnmatchedAccountsInReview />
            case qarManagersMenuOptions.viewAllDelegatedEmployees:
                return <QarDelegatedEmployeesByAccount />
            default:
                break;
        }
    };

    const handleTextFieldChange = (event) => {
        event.preventDefault();
        setIsInvalidInput(false)
        setComment(event.target.value.trim());
    };

    return <div id="qar-managers-panel">

        <button className="btn" id="back-btn" onClick={() => backBtnClickHandler()}>
            <i className="fas fa-arrow-alt-circle-left"></i>   Back
        </button>

        <div className='qar-managers-content-wrapper'>
            <QarManagersOptionsMenu
                shouldRenderChameleonAdminEmployeeReviews={props.activeSystemName === chameleonSystem}
                updateActiveItem={updateActiveItem} />

            <div id="system-accounts">
                {renderTableComponent()}
            </div>
        </div>
        <Modal
            open={RootStore.qarStore.isCommentSectionOpened}
            onClose={((handleContentModalClose))}
            aria-labelledby="role-modal-title"
            aria-describedby="role-modal-description"
        >
            <div className="role-content-modal" id="comment-modal">
                <MaterialTable
                    style={{whiteSpace:"pre-line"}}
                    data={RootStore.qarStore.currenlySelectedCommentSection}
                    columns={managerReviewCommentsColumns}
                    options={managerReviewCommentsOptions}
                />
                        <TextField
                        error={isInvalidInput}
                        style={{margin:"10px 0"}}
                        label="Write a comment..." 
                        variant="outlined"
                        multiline={true}
                        minRows={6}
                        fullWidth={true}
                        onChange={(e) => handleTextFieldChange(e)} />
                        <Button
                        color='primary'
                        disabled = {RootStore.qarStore.isManagerReviewsCompleted || isInvalidInput}
                        variant="contained"
                        onClick={(e) => submitComment(e)}
                        >
                            Save
                        </Button>
            </div>
        </Modal>
        <Modal
            open={RootStore.qarStore.isCommentFormOpened}
            onClose={((handleContentModalClose))}
            aria-labelledby="role-modal-title"
            aria-describedby="role-modal-description"
        >
            <div className="role-content-modal" id="comment-modal">
                <form id="comment-form">
                    <div className="form-group">
                        <input id="comment-field" type="email" className="form-control" placeholder="Write a comment ..." />
                    </div>
                    <div className="btn btn-primary" onClick={submitComment}>Save</div>
                </form>
            </div>
        </Modal>
        <Modal
            open={RootStore.qarStore.isReviewsHistoryOpened}
            onClose={((handleReviewsHistoryModalClose))}
            aria-labelledby="role-modal-title"
            aria-describedby="role-modal-description"
        >
            <div className="review-history-modal" id="review-history-modal">
                <MaterialTable
                    data={RootStore.qarStore.reviewHistory}
                    columns={reviewHistoryColumns}
                    options={reviewHistoryOptions}
                />
            </div>
        </Modal>
    </div>
}));

export default QarManagers;